<template>
    <aside class="mdc-drawer">
                <div class="drawer-wrapper">
                    <div class="mdc-drawer__header">
                        <div class="d-flex mgt-24 mgl-18 mgb-8 mgr-16 align-items-center justify-content-between">
                            <div class="position-relative">
                                <img src="/img/avatar-setting.svg" class="circle" alt="">
                                <div
                                    class="profile-setting-icon b-radius50 bg-white w-32 h-32 d-flex align-items-center justify-content-center">
                                    <i class="material-icons t-color-iconInactive w-22 h-22">settings</i>
                                </div>
                            </div>
                            <!-- <i class="material-icons setting">inbox</i> -->
                        </div>


                        <h3 class="mdc-drawer__title t-subtitle3 font-m pdl-18">홍길동</h3>
                        <div class="d-flex mgt-8 pdl-18">
                            <div class="t-body2 t-color-bodyGrayA font-m pdr-11">직무</div>
                            <div class="t-body2 t-color-bodyGrayA font-m ">직책</div>
                        </div>
                    </div>
                    <div class="mdc-drawer__content">
                        <nav class="mdc-list mgb-50">
                            <a class="mdc-list-item mgt-8" href="#">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35">folder</i>
                                <span class="mdc-list-item__text">리더보드</span>
                                <i
                                    class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA">keyboard_arrow_down</i>
                            </a>
                            <div class="divider"></div>
                            <a class="mdc-list-item mdc-list-item--activated mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">subscriptions</i>
                                <span class="mdc-list-item__text t-body2">나의 온라인 학습</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item mgt-8" href="#">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35">import_contacts</i>
                                <span class="mdc-list-item__text">나의 오프라인 학습</span>
                                <i
                                    class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item mgt-8" href="#">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35">grade</i>
                                <span class="mdc-list-item__text">리워드</span>
                                <i
                                    class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA">keyboard_arrow_down</i>
                            </a>

                            <div class="divider"></div>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">play_circle</i>
                                <span class="mdc-list-item__text t-body2">온라인 강의</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item mgt-8" href="#">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35">create</i>
                                <span class="mdc-list-item__text">오프라인 강의</span>
                                <i
                                    class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item mgt-8" href="#">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35">done_all</i>
                                <span class="mdc-list-item__text">시험</span>
                                <i
                                    class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item mgt-8" href="#">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35">pie_chart</i>
                                <span class="mdc-list-item__text">시험</span>
                                <i
                                    class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA">keyboard_arrow_down</i>
                            </a>
                            <div class="divider"></div>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">local_library</i>
                                <span class="mdc-list-item__text t-body2">나의 포트폴리오</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <div class="divider"></div>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">event_available</i>
                                <span class="mdc-list-item__text t-body2">이벤트</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">format_quote</i>
                                <span class="mdc-list-item__text t-body2">이벤트</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <div class="divider"></div>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">shopping_cart</i>
                                <span class="mdc-list-item__text t-body2">나의 구매 내역</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">credit_card</i>
                                <span class="mdc-list-item__text t-body2">환불 신청결과</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <div class="divider"></div>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">person</i>
                                <span class="mdc-list-item__text t-body2">나의 정보</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">settings</i>
                                <span class="mdc-list-item__text t-body2">설정</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">help</i>
                                <span class="mdc-list-item__text t-body2">헬프데스크</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">autorenew</i>
                                <span class="mdc-list-item__text t-body2">서비스 선택</span>
                                <i class="material-icons mdc-list-item__graphic mgl-auto mgr-16 t-color-bodyGrayA"
                                    aria-hidden="true">keyboard_arrow_down</i>
                            </a>
                            <div class="divider"></div>
                            <a class="mdc-list-item d mgt-12" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">logout</i>
                                <span class="mdc-list-item__text t-body2">로그아웃</span>
                            </a>
                            <div class="divider"></div>
                            <a class="mdc-list-item d mgt-12 align-items-start" href="#" aria-current="page">
                                <span class="mdc-list-item__ripple"></span>
                                <i class="material-icons mdc-list-item__graphic mgl-16 mgr-35"
                                    aria-hidden="true">history</i>
                                <div>
                                    <div class="mdc-list-item__text">최근 로그인</div>
                                    <div class="mdc-list-item__text t-body3 t-bodyGrayB">최근 2020.04.07 13:56</div>
                                </div>
                            </a>

                        </nav>
                    </div>
                </div>
            </aside>
</template>

<script>
/**
 * 네비게이션 드로워 게스트 컴포넌트(navigation drawer guest Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

export default {
    props: ['isDrawerOpen'],
    components: {
        
    },
    
    data() {
        return {
            token: localStorage.getItem('token'),
            brandLogo: localStorage.getItem('brandLogo'),
            brandName: localStorage.getItem('brandName'),
            drawer: null,
            drawerList: null,
        }
    },

    methods: {
        closeDrawer() {
            this.$emit('closeDrawer')
        },
       
    }
}
</script>